import { type FC, useMemo, useState } from 'react';

import { type Chart as ChartElement } from '@editor2/types/pageElements';
import ChartDataTable from './ChartDataTable';
import Pagination from '@editor2/components/Pagination/Paginations';
import { DEFAULT_ROW_DISPLAY_COUNT } from '@editor2/components/Pagination/constants';
import { chartDataTableWrapperStyle } from './styles';

interface Props {
	courseId: number;
	element: ChartElement;
}

const ChartDataTableWithPagination: FC<Props> = (props) => {
	const { element, courseId } = props;

	const [currentPage, setCurrentPage] = useState(1);
	const [pageSize, setPageSize] = useState(DEFAULT_ROW_DISPLAY_COUNT);

	const currentTableData = useMemo(() => {
		const firstPageIndex = (currentPage - 1) * pageSize;
		const lastPageIndex = firstPageIndex + pageSize;

		const data = element.data?.slice(1).slice(firstPageIndex, lastPageIndex); //
		return data || [];
	}, [currentPage, pageSize, element]);

	return (
		<>
			<div className={chartDataTableWrapperStyle}>
				<ChartDataTable
					element={element}
					currentPageData={currentTableData}
					courseId={courseId}
					currentPage={currentPage}
					limit={pageSize}
				/>
			</div>

			<Pagination
				currentPage={currentPage}
				pageSize={pageSize}
				setPageSize={setPageSize}
				totalCount={element.data.length - 1}
				onPageChange={(page) => setCurrentPage(page)}
			/>
		</>
	);
};

export default ChartDataTableWithPagination;
